export const MOTRICITE_GLOBALE_LABELS: Record<string, string> = {
  retourneDosVersCote: 'Se retourne du dos vers côté',
  ventreSouleveTeteEpaule: 'Sur le ventre, soulève la tête et les épaules',
  maintientTete: 'Maintient sa tête',
  retourneVentreVersDos: 'Se retourne du ventre au dos',
  retourneDosVersVentre: 'Se retourne du dos au ventre',
  ventreAvion: 'Sur le ventre, fait « l\'avion »',
  ventreSouleveTeteEpauleAppuieAvantBras: 'Sur le ventre, soulève la tête et les épaules et s\'appuie sur les avant-bras',
  pedalPied: 'Pédale avec ses pieds',
  attrapePied: 'Attrape ses pieds',
  metPiedBouche: 'Met ses pieds à la bouche',
  tientAssisAvecSoutien: 'Tient assis avec soutien',
  tientAssisSansAppui: 'Tient assis sans appui',
  assoitSeul: 'S\'assoit seul',
  deplaceEnRampant: 'Se déplace en rampant',
  deplaceEnRoulant: 'Se déplace en roulant',
  deplaceAReculons: 'Se déplace à reculons',
  deplaceQuatrePatte: 'Se déplace à quatre pattes',
  deplaceFesse: 'Se déplace sur les fesses',
  deplaceMainsPlantePied: 'Se déplace sur les mains et plantes de pieds (marche de l\'ours)',
  tientDeboutAvecSupport: 'Tient debout avec support',
  tientDeboutSansAppui: 'Tient debout sans appui',
  marcheTenantMain: 'Marche en tenant les mains',
  faitQuelquePas: 'Fait quelques pas',
  marcheAcquise: 'Marche acquise',
  marchePointePied: 'Marche sur la pointe des pieds',
  relevePositionAssiseSansAppui: 'Se relève de la position assise sans appui',
  court: 'Court',
  monteEscalierAvecAide: 'Monte les escaliers avec aide',
  monteEscalierSeul: 'Monte les escaliers seul',
  monteEscalierAlternantPied: 'Monte les escaliers en alternant les pieds',
  descendEscalier: 'Descend les escaliers',
  pedaleSurVelo: 'Pédale sur le vélo',
  grimpe: 'Grimpe',
  tientDeboutSurPied: 'Tient debout sur un pied',
  sautePiedJoint: 'Saute à pieds joints',
  sauteSurUnPied: 'Saute sur un pied',
  lanceUneBalle: 'Lance une balle',
  tapePiedDansBallon: 'Tape du pied dans un ballon',
};

export const MOTRICITE_FINE_LABELS: Record<string, string> = {
  attrapeInvolontairement: 'Attrape involontairement un objet placé dans sa main (préhension involontaire ou au contact)',
  attrapeVolontairement: 'Attrape volontairement un objet (préhension palmaire et imprécise)',
  attrapePinceInferieure: 'Attrape en faisant la pince inférieure (entre pouce et auriculaire)',
  relacheVolontairementImprecis: 'Relâche volontairement un objet (global et imprécis)',
  attrapePinceSuperieure: 'Attrape un objet en faisant la pince supérieure (entre pouce et index)',
  mainObjetBouche: 'Porte ses mains ou un objet à la bouche',
  joueAvecAmi: 'Joue avec ses mains',
  objetChangementMain: 'Passe un objet d\'une main à l\'autre',
  relacheVolontairementPrecis: 'Relâche volontairement (fin et précis)',
  donneObjet: 'Donne un objet sur ordre',
  jetteObjet: 'Jette un objet',
  superposeCube2: 'Superpose 2 cubes',
  superposeCube3: 'Superpose 3 cubes',
  tournePageLivre: 'Tourne les pages d\'un livre',
  recopieLigneVerticale: 'Recopie une ligne verticale',
  recopieLigneHorizontale: 'Recopie une ligne horizontale',
  recopieCercleFerme: 'Recopie un cercle fermé',
  faitTourCube6A8: 'Fait une tour de 6 à 8 cubes',
  emboiteForme: 'Emboîte des formes',
  devisseRevisseBouchon: 'Dévisse et revisse le bouchon d\'un flacon',
  tientCrayonPince: 'Tient un crayon en faisant la pince',
};

export const AUTONOMIE_LABELS: Record<string, string> = {
  metChauss: 'Met ses chaussettes / chaussures / chaussons',
  retireChauss: 'Retire ses chaussettes / chaussures / chaussons',
  deshabilleSeul: 'Se déshabille seul',
  habilleSeul: 'S\'habille seul',
};

export const LANGAGE_LABELS: Record<string, string> = {
  gazouille: 'Gazouille',
  babille: 'Babille',
  reagiPrenom: 'Réagit à son prénom',
  ditUnMot: 'Dit un mot (mama, papa, pain, doudou …)',
  associeDeuxMots: 'Associe deux mots (papa pati, bébé bobo)',
  poseQuestion: 'Pose des questions simples « C\'est quoi ? »',
  ditPrenom: 'Dit son prénom',
  nommePartieCorps: 'Nomme les parties du corps',
  nommeCouleur: 'Nomme des couleurs',
  comprendConsigne: 'Comprend une consigne simple',
  comprendPhraseCourte: 'Comprends une phrase courte',
  ditJe: 'Dit « je » quand il parle de lui',
  utiliseVerbeEtPhrase: 'Utilise le verbe et fait des phrases explicites',
};

export const MOMENT_SIESTE_LABELS: Record<string, string> = {
  uniquementMatin: 'Uniquement matin',
  matinAM: 'Matin et après-midi',
  uniquementAM: 'Uniquement après-midi',
  aucunRythme: 'Pas de rythme déterminé',
};

export const BOIT_LABELS: Record<string, string> = {
  biberon: 'Au biberon',
  tasseABec: 'A la tasse à bec',
  gobelet: 'Au gobelet',
};

export const MANGE_LABELS: Record<string, string> = {
  avecDoigt: 'Avec ses doigts',
  avecCuillereFourchette: 'Avec une cuillère / fourchette',
};

export const AUTONOMIE_REPAS_LABELS: Record<string, string> = {
  tientBiberon: 'Tient son biberon',
  porteCuillereBouche: 'Porte la cuillère à sa bouche',
  accepteDoubleCuillere: 'Accepte la double cuillère',
};

export const TEXTURE_LABELS: Record<string, string> = {
  mixe: 'Mixé', mouline: 'Mouliné', morceau: 'Morceaux',
};

export const DIVERSIFICATION_STATUT_LABELS: Record<string, string> = {
  pasCommence: "N'a pas commencé", enCours: 'Est en cours', mangeTout: 'Mange de tout',
};

export const PORT_COUCHE_LABELS: Record<string, string> = {
  systematiquement: 'Porte systématiquement des couches',
  noCoucheSieste: 'Ne porte plus de couche à la sieste',
  noCoucheJournee: 'Ne porte plus de couche en journée',
};

export const CHANGE_LABELS: Record<string, string> = {
  uniquementEau: "A l'eau uniquement",
  eauSavonCreche: "A l'eau et au savon de la crèche",
  produitSpecifique: 'Avec un produit spécifique',
};

export const BIBERON_LABELS: Record<string, string> = {
  perso: 'Perso', creche: 'Biberon de la crèche',
};

export const LAIT_LABELS: Record<string, string> = {
  persoOuLait: 'Perso ou lait', creche: 'Crèche',
};

export const EAU_LABELS: Record<string, string> = {
  perso: 'Perso', creche: 'Eau de la crèche',
};

export const TEMPERATURE_LABELS: Record<string, string> = {
  ambiante: 'Ambiante', chauffee: 'Chauffée',
};

export const TYPE_REPAS_LABELS: Record<string, string> = {
  potAssiette: 'Pots / assiettes industrielles', repasCuisine: 'Repas cuisinés',
};

export const QUANTITE_REPAS_LABELS: Record<string, string> = {
  quelqueCuillere: 'Quelques cuillères', g65: '65g', g100: '100g',
  g135: '135g', g200: '200g', g250: '250g',
};

export const LEGUME_FECULENT_06_LABELS: Record<string, string> = {
  g65: '1 pot de 65 g (= ½ pot de 130g) = 4/6 mois',
  g130: '1 pot de 130g = 4/6 mois',
  g100: '1 pot de 100 g (= ½ de 200g) = 6 mois',
  g200: '1 pot de 200 g = 6 mois',
};

export const LEGUME_FECULENT_6PLUS_LABELS: Record<string, string> = {
  g200m6: 'pot de 6 mois (200g)',
  g200m8: 'pot 8 mois (200g)',
  g200m12: 'pot ou assiette 12 mois (200g ou 230g)',
  g250m15: 'assiette 15 mois (250g)',
  g250m18: 'assiette 18 mois (250g)',
  g250m24: 'assiette 24 mois (250g)',
};

export const HYGIENE_ENFANT_LABELS: Record<string, string> = {
  ditQuandCoucheSale: 'Dit / manifeste quand sa couche est sale',
  interessePotToilette: 'Est intéressé par le pot ou les toilettes',
  potWCSansFaire: 'Va sur le pot / WC lors des changes mais ne fait pas ses besoins',
  potWCFait: 'Lors des changes, va sur le pot / WC et fait ses besoins',
  aucuneCoucheJournee: 'Ne porte plus de couche en journée',
  aucuneCoucheSieste: 'Ne porte plus de couche à la sieste',
};

export const SURVEILLANCE_SYMPTOMES_LABELS: Record<string, string> = {
  checkbox_peauChaude: 'Peau chaude',
  checkbox_oeilBrillant: 'Yeux brillants',
  checkbox_pleurInhabituel: 'Pleurs inhabituels',
  checkbox_comportementInhabituel: 'Comportement inhabituel',
  checkbox_diminutionActivite: "Apathie ou diminution d'activité",
  checkbox_douleur: 'Douleurs',
  checkbox_antecedentTemperature: 'Antécédent de T° dans les dernières 24h',
  checkbox_vomissement: 'Vomissements',
  checkbox_selleLiquide: 'Selles liquides à répétition',
  checkbox_surveillanceVaccin: 'Surveillance suite vaccin',
  checkbox_surveillanceAntipyretique: 'Surveillance suite antipyrétique',
  checkbox_surevillanceDemandeParent: 'Surveillance demandée par parents',
  checkbox_convulsionHyperthermique: 'Convulsions hyperthermiques',
  checkbox_paleurOuBleu: 'Pâleur ou extrémités bleues',
  checkbox_tremblement: 'Tremblements',
  checkbox_troubleRespiration: 'Troubles de la respiration',
  checkbox_contexteEpidemique: 'Contexte épidémique',
  checkbox_autre: 'Autre',
};

export const MEDICAMENT_ADMINISTRE_LABELS: Record<number, string> = {
  1: 'Paracétamol (Doliprane)',
  2: 'Autre',
};

export const POSOLOGIE_LABELS: Record<number, string> = {
  1: 'Buvable dose poids',
  2: 'Suppositoire 100 mg',
  3: 'Suppositoire 150 mg',
  4: 'Suppositoire 200 mg',
};

export const COMMENT_PARENT_AVERTI_LABELS: Record<number, string> = {
  1: 'En direct',
  2: 'Email / SMS / répondeur',
};

export const DIVERSIFICATION_GROUPES: {
  label: string;
  theme: string;
  labelsMap: Record<string, string>;
}[] = [
  { label: 'Légumes verts', theme: 'checkbox_legumeVert_detail', labelsMap: { courgette: 'Courgette', haricot: 'Haricot', epinard: 'Épinard', petitPois: 'Petits pois', artichaut: 'Artichaut', brocoli: 'Brocoli' } },
  { label: 'Légumes du potager', theme: 'checkbox_legumePotager_detail', labelsMap: { carotte: 'Carotte', potiron: 'Potiron', chouFleur: 'Chou-fleur', poireaux: 'Poireaux', champignon: 'Champignon' } },
  { label: 'Légumes du soleil', theme: 'checkbox_legumeSoleil_detail', labelsMap: { tomate: 'Tomate', aubergine: 'Aubergine', poivron: 'Poivron' } },
  { label: 'Légumes présents en trace', theme: 'checkbox_legumeTrace_detail', labelsMap: { celeri: 'Céleri', navet: 'Navet', panais: 'Panais', mais: 'Maïs', oignon: 'Oignon' } },
  { label: 'Fruits du verger', theme: 'checkbox_fruitVerger_detail', labelsMap: { pomme: 'Pomme', poire: 'Poire', peche: 'Pêche', abricot: 'Abricot', coing: 'Coing', mirabelle: 'Mirabelle', prunePruneau: 'Prune / Pruneau', rhubarbe: 'Rhubarbe' } },
  { label: 'Fruits du soleil', theme: 'checkbox_fruitSoleil_detail', labelsMap: { banane: 'Banane', ananas: 'Ananas', kiwi: 'Kiwi', mangue: 'Mangue', fruitPassion: 'Fruit de la passion', goyave: 'Goyave' } },
  { label: 'Fruits rouges', theme: 'checkbox_fruitRouge_detail', labelsMap: { fraise: 'Fraise', framboise: 'Framboise', myrtille: 'Myrtille', mure: 'Mûre', groseille: 'Groseille', cerise: 'Cerise', cassis: 'Cassis' } },
  { label: 'Agrumes', theme: 'checkbox_agrume_detail', labelsMap: { mandarineClementine: 'Mandarine / Clémentine', orange: 'Orange', citron: 'Citron' } },
  { label: 'Viandes', theme: 'checkbox_viande_detail', labelsMap: { jambonPorc: 'Jambon / Porc', poulet: 'Poulet', DindeDindonneau: 'Dinde / Dindonneau', veau: 'Veau', agneau: 'Agneau' } },
  { label: 'Poissons', theme: 'checkbox_poisson_detail', labelsMap: { saumon: 'Saumon', cabillaud: 'Cabillaud', colinLieu: 'Colin / Lieu', merlu: 'Merlu', thon: 'Thon' } },
  { label: 'Féculents', theme: 'checkbox_feculent_detail', labelsMap: { pommeDeTerre: 'Pomme de terre', patateDouce: 'Patate douce', pate: 'Pâtes', riz: 'Riz', semoule: 'Semoule', bleBoulghour: 'Blé / Boulghour', quinoa: 'Quinoa' } },
  { label: 'Autres', theme: 'checkbox_autre_detail', labelsMap: { oeuf: 'Oeufs', vanille: 'Vanille', chocolat: 'Chocolat', caramel: 'Caramel', biscuit: 'Biscuit', semouleLait: 'Semoule au lait', compoteBiscuit: 'Compote au biscuit' } },
];
